import { useState } from "react";
import { api } from "../api";
import { Upload as UploadIcon } from "lucide-react";

function UploadCard({ title, desc, endpoint, extraField, testId }) {
  const [file, setFile] = useState(null);
  const [period, setPeriod] = useState("Apr–Jun 2026");
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit(e) {
    e.preventDefault();
    if (!file) return;
    setBusy(true); setMsg("");
    const form = new FormData();
    form.append("file", file);
    if (extraField) form.append(extraField, period);
    try {
      const { data } = await api.post(endpoint, form);
      setMsg(`✅ Uploaded: ${data.recordCount ?? data.total ?? "OK"} records. Upload ID: ${data.uploadId}`);
      setFile(null);
      e.target.reset();
    } catch (ex) {
      setMsg(`❌ ${ex?.response?.data?.detail || "Upload failed"}`);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="bg-white rounded-xl border border-slate-200 p-6" data-testid={testId}>
      <div className="flex items-center gap-2 mb-1">
        <UploadIcon size={18} style={{ color: "#00a3a3" }} />
        <h3 className="text-lg font-semibold" style={{ color: "#1a3666" }}>{title}</h3>
      </div>
      <p className="text-sm text-slate-500 mb-4">{desc}</p>
      <form onSubmit={submit} className="space-y-3">
        <input type="file" accept=".xlsx,.xls" required
               onChange={(e) => setFile(e.target.files[0])} data-testid={`${testId}-file`}
               className="w-full text-sm" />
        {extraField && (
          <input type="text" placeholder="Reporting period e.g. Apr–Jun 2026" value={period}
                 onChange={(e) => setPeriod(e.target.value)}
                 className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm" />
        )}
        <button type="submit" disabled={busy || !file} data-testid={`${testId}-submit`}
                className="px-4 py-2 rounded-md text-white text-sm font-semibold disabled:opacity-60"
                style={{ background: "#1a3666" }}>
          {busy ? "Uploading…" : "Upload"}
        </button>
        {msg && <div className="text-sm mt-2" data-testid={`${testId}-msg`}>{msg}</div>}
      </form>
    </div>
  );
}

export default function Upload() {
  return (
    <div data-testid="upload-page">
      <h2 className="text-xl font-bold mb-5" style={{ color: "#1a3666" }}>Upload Data</h2>
      <div className="grid gap-5" style={{ gridTemplateColumns: "repeat(auto-fit,minmax(340px,1fr))" }}>
        <UploadCard testId="billability-upload" title="Billability Excel"
                    desc="Resource Load / Utilization Excel (columns: CC, Portfolio, POC, Name, Project, Apr, May, Jun, Total)"
                    endpoint="/upload" extraField="period" />
        <UploadCard testId="leave-upload" title="Leave Report Excel"
                    desc="Leave Report Excel (columns: Employee, CC, Portfolio, Year, Total, Applied for, Approved, Taken, Available, …)"
                    endpoint="/leaves/upload" />
      </div>
    </div>
  );
}
